import React from 'react';
import InfoTooltip from 'shared/components/info-tooltip';
import ComparePctWithAverage from './compare-pct-with-average';
import {NationalCollegeData} from 'src/types/college-profile';

interface Props {
  college: {
    studentsEarningAboveHighSchoolGrads?: number;
  };
  nationalCollegeData: NationalCollegeData;
}

const CompareEarningAboveHighSchool = ({college, nationalCollegeData}: Props) => {
  if (!college.studentsEarningAboveHighSchoolGrads) {
    return null;
  }

  const tooltip = (
    <InfoTooltip className="college-profile-tooltip">
      The share of former students earning more than $25,000, or about the average earnings of a
      high school graduate aged 25-34, 6 years after they first enroll
    </InfoTooltip>
  );

  return (
    <ComparePctWithAverage
      label="Students Earning above High School Grads"
      dataSource={nationalCollegeData}
      attributeInSource="studentsEarningAboveHighSchoolGrads"
      attributeOnCollege="studentsEarningAboveHighSchoolGrads"
      college={college}
      tooltip={tooltip}
    />
  );
};

export default CompareEarningAboveHighSchool;
